import axios from "axios";

// создаём экземпляр axios с базовым URL
const api = axios.create({
  baseURL: "https://thebestmarket.ru/api",
  // baseURL: "https://b-dev.thebestmarket.ru",

  // Без таймаута запрос на плохом мобильном интернете мог висеть бесконечно
  timeout: 15000,
});

export default api;
